import {
  handleUrl,
  myHeadersWithToken,
  myHeadersWithTokenContentType,
} from '../global';
import {
  ApproveElementData,
  DetailProps,
  EditSamplesData,
  GeometryProps,
  GetCheckSampleProps,
  GetElementPicturesProps,
  GetElementProps,
  GetOriginalElementProps,
  GetSampleProps,
} from './types';

export const checkSample = (
  id: number,
  supply: number,
  maxRadius: number
): Promise<GetCheckSampleProps> => {
  const requestOptions = {
    method: 'GET',
    headers: myHeadersWithTokenContentType(),
  };
  const baseUrl = handleUrl();
  return fetch(
    // eslint-disable-next-line max-len
    `${baseUrl}/api/V1/work-orders/${id}/search-samples?supply_factor=${supply}&max_radius=${maxRadius}`,
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const getSample = (
  id: number,
  page: number,
  size: number
): Promise<GetSampleProps> => {
  const requestOptions = {
    method: 'GET',
    headers: myHeadersWithTokenContentType(),
  };
  const baseUrl = handleUrl();
  return fetch(
    `${baseUrl}/api/V1/work-orders/${id}/samples?page=${page}&size=${size}`,
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const getElementPictures = (
  id: number,
  page: number,
  size: number
): Promise<GetElementPicturesProps> => {
  const requestOptions = {
    method: 'GET',
    headers: myHeadersWithTokenContentType(),
  };
  const baseUrl = handleUrl();
  return fetch(
    `${baseUrl}/api/V1/samples/${id}/pictures?page=${page}&size=${size}`,
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const getAllElementPictures = (
  id: number
): Promise<GetElementPicturesProps> => {
  const requestOptions = {
    method: 'GET',
    headers: myHeadersWithTokenContentType(),
  };
  const baseUrl = handleUrl();
  return fetch(
    `${baseUrl}/api/V1/samples/${id}/search-sample-pictures`,
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const approveElement = (
  id: number,
  data: ApproveElementData
): Promise<DetailProps> => {
  const requestOptions = {
    method: 'PUT',
    headers: myHeadersWithTokenContentType(),
    body: JSON.stringify(data),
  };
  const baseUrl = handleUrl();
  return fetch(`${baseUrl}/api/V1/samples/${id}/approve`, requestOptions)
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const addNewElement = (data: FormData): Promise<DetailProps> => {
  const requestOptions = {
    method: 'POST',
    headers: myHeadersWithToken(),
    body: data,
  };
  const baseUrl = handleUrl();
  return fetch(`${baseUrl}/api/V1/samples`, requestOptions)
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const editElement = (
  id: number,
  data: EditSamplesData
): Promise<DetailProps> => {
  const requestOptions = {
    method: 'PUT',
    headers: myHeadersWithTokenContentType(),
    body: JSON.stringify(data),
  };
  const baseUrl = handleUrl();
  return fetch(`${baseUrl}/api/V1/samples/${id}`, requestOptions)
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const deleteElement = (id: number): Promise<DetailProps> => {
  const requestOptions = {
    method: 'DELETE',
    headers: myHeadersWithToken(),
  };
  const baseUrl = handleUrl();
  return fetch(`${baseUrl}/api/V1/samples/${id}`, requestOptions)
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const getElement = (id: number): Promise<GetElementProps> => {
  const requestOptions = {
    method: 'GET',
    headers: myHeadersWithTokenContentType(),
  };
  const baseUrl = handleUrl();
  return fetch(`${baseUrl}/api/V1/samples/${id}`, requestOptions)
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const getOriginalElement = (
  id: number,
  update: boolean
): Promise<GetOriginalElementProps> => {
  const requestOptions = {
    method: 'GET',
    headers: myHeadersWithTokenContentType(),
  };
  const baseUrl = handleUrl();
  return fetch(
    `${baseUrl}/api/V1/samples/${id}/original-element?should_perform_update=${update}`,
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const getCoordinates = (
  address: string,
  apiKey: string
): Promise<GeometryProps> => {
  const requestOptions = {
    method: 'GET',
  };

  return fetch(
    `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
      address
    )}&key=${apiKey}`,
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};
